import type { DialogAPI } from '@fukku/dialog'
import type { Product } from 'product/types'
import type { RefObject } from 'react'
import { useCallback } from 'react'
import type { SelectedSize } from '../../SizesList/SizesList'
import { useBackInStock } from '../useBackInStock/useBackInStock'
import { useSelectedRelatedSize } from '../useSelectedRelatedSize/useSelectedRelatedSize'

export function useSelectedSize(
	onSelectedSize: ((selectedSize: SelectedSize) => void) | undefined,
	productId: string,
	selectedColorId: string,
	product: Product,
	bottomSheetRef: RefObject<DialogAPI | null>
) {
	const { handleBackInStock } = useBackInStock()
	const { setRelatedSelected } = useSelectedRelatedSize(
		handleBackInStock,
		productId
	)

	return useCallback(
		(props: SelectedSize) => {
			const isRelatedSize = !!props.size.relatedProductId
			const { size } = props
			if (size.available) {
				onSelectedSize?.(props)
				bottomSheetRef.current?.close()
			} else if (isRelatedSize) {
				setRelatedSelected(props)
			} else {
				handleBackInStock({
					product: productId,
					color: selectedColorId,
					size: size.id,
					name: product.name,
				})
			}
		},
		[
			onSelectedSize,
			handleBackInStock,
			product,
			productId,
			selectedColorId,
			setRelatedSelected,
			bottomSheetRef,
		]
	)
}
